import React from 'react'

import Terms, { TermsProps } from 'components/Terms'

const TermsCremation = ({ pageContext }: TermsProps) => (
  <Terms pageContext={pageContext} />
)

export default TermsCremation
